import angularJsUtilitiesModule from "../angularJsUtilitiesModule";

const keyCode = {
    enter: 13,
    esc: 27
};

angularJsUtilitiesModule.constant("keyCode", keyCode);
export default keyCode;